// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import LoginPage from './pages/admin/LoginPage';

// Import Components and Pages
import Navbar from './components/Navbar';
import Copyright from './components/Copyright';
import MiniContact from './components/MiniContact';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ContactPage from './pages/ContactPage';
import ContactsView from './pages/admin/ContactsView';
import ProjectsManager from './pages/admin/ProjectsManager';
import { API_URL } from './config';
import { initAnalytics, trackPageView, trackEvent } from './analytics';

// A new component to decide which footer to show
const AppFooter = () => {
  const location = useLocation();
  // Show the simple copyright only on the contact page
  if (location.pathname === '/contact') {
    return <Copyright />;
  }
  // Show the full footer on all other pages
  return <MiniContact />;
};

// גלילה לראש העמוד + דיווח צפייה לאנליטיקס בכל מעבר בין עמודים
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

const NotFoundPage = () => (
  <div id="main">
    <section className="post" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
      <h1>404 — העמוד לא נמצא</h1>
      <p>העמוד שחיפשתם לא קיים. אולי תמצאו את מה שחיפשתם באחד מהעמודים הבאים:</p>
      <ul className="actions special" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', listStyle: 'none', padding: 0 }}>
        <li><Link to="/" className="button">דף הבית</Link></li>
        <li><Link to="/projects" className="button">פרויקטים</Link></li>
        <li><Link to="/contact" className="button primary">צור קשר</Link></li>
      </ul>
    </section>
  </div>
);

function App() {
  useEffect(() => {
    // "מעיר" את השרת (Render נרדם אחרי חוסר פעילות) כדי שמערכת הניהול תגיב מהר
    fetch(`${API_URL}/api/health`).catch(() => {});

    initAnalytics();

    // מעקב אוטומטי אחרי כל לחיצה על חיוג או וואטסאפ בכל האתר
    const handleClick = (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (href.startsWith('tel:')) trackEvent('phone_click');
      else if (href.includes('wa.me')) trackEvent('whatsapp_click');
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <Router>
      <div id="wrapper">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/project/:projectId" element={<ProjectDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/contacts" element={<ContactsView />} />
          <Route path="/admin/projects" element={<ProjectsManager />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <AppFooter />
      </div>
    </Router>
  );
}

export default App;
